import { useWorkOrdersContext } from "../context/workOrdersContext";
import type { EditableCallbackParams } from "ag-grid-community";
import Grid2 from '@mui/material/Grid2';

type Props = EditableCallbackParams;

export const AssetNameColumnColumn = ({ data }: Props) => {
	const {
		state: { dataToGetWorkOrders: { assetSearchName } },
	} = useWorkOrdersContext();
	if (data?.id === -1) {
		return (
			<Grid2 spacing={1}
				style={{ alignItems: "center", justifyContent: "center" }}>
				<Grid2 style={{ alignItems: "center", justifyContent: "center" }}>
					{assetSearchName}
				</Grid2>
			</Grid2>
		);
	} else if (data?.id !== -1) {
		return <div title={data?.AssetName}>{data?.AssetName}</div>;
	} else return <></>;
};
